<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">{{ $t('numerex.card.title') }}</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <numerex-form ref="numerexForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <sidebar-actions
        :model.sync="numerex"
        @save="save"
        @generate="generate"
        @clear="clear"
      />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import NumerexForm from './NumerexForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_NUMEREX_MODEL_, MODEL } from './NumerexModel';

export default {
  name: 'numerex-page',
  components: {
    NumerexForm,
    SidebarActions,
  },
  data() {
    return {
      fallbackModel: cloneDeep(MODEL),
    };
  },
  computed: {
    storeNumerex() {
      return this.$store.state.numerex.numerex;
    },
    numerex() {
      return this.storeNumerex || this.fallbackModel;
    },
  },
  watch: {
    storeNumerex: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          Events.$emit(_LOAD_NUMEREX_MODEL_, newValue);
        }
      },
    },
  },
  methods: {
    save() {
      this.$refs.numerexForm.save();
    },
    generate() {
      this.$refs.numerexForm.generate();
    },
    clear() {
      this.$refs.numerexForm.clear();
    },
  },
};
</script>
